import { memo, useContext } from "react";
import Container from "./Container";
import img1 from "../assets/images/sampleVideo.avif";
import { Apicontext } from "../context/ContextApi";
import AppIcons from "../assets/icons/AppIcon";
import { Circles } from "react-loader-spinner";
import ENV from "../config/env";
const Download = memo(() => {
  const {
    urlReturnData,
    loading,
  }: { urlReturnData: any; getVideo: any; loading: boolean } =
    useContext(Apicontext);
  const submitFormateVideo = () => {
    const videoUrl = `${ENV.REACT_APP_BASE_URL}/${urlReturnData.filePath}`;

    const downloadLink = document.createElement("a");
    downloadLink.href = videoUrl;
    downloadLink.download = "video.mp4"; // Replace 'video.mp4' with the desired file name and extension
    downloadLink.click();
  };
  const handleError = (event: any) => {
    event.target.src = img1; // Set the path to your default image
  };
  return (
    <div className="py-20 relative">
      {loading ? (
        <div className=" absolute z-100 bg-opacity-40 bg-black w-full top-0 bottom-0 left-0 right-0 flex justify-center items-center ">
          <Circles color="#3dd6bf" />
        </div>
      ):
      <Container>
        <>
          <div className="flex flex-col md:flex-row justify-center">
            <div className=" basis-[40%] ">
              <p className=" text-lg font-medium">Your videos is ready</p>
              <img
                src={urlReturnData?.thumbnailURL}
                onError={handleError}
                alt="img"
                className="w-72 mx-auto pt-6"
              />
              {/* <video
                src={urlReturnData?.fallbackUrl}
                poster={
                  urlReturnData?.thumbnailURL.includes("http")
                    ? urlReturnData?.thumbnailURL
                    : img1
                }
                className="w-72 max-h-[300px] mx-auto pt-6"
              /> */}
            </div>
            <div className=" basis-[60%] pt-16 mx-2 sm:mx-4 lg:mx-2">
              <h2 className=" text-lg font-medium pb-2 capitalize">
                {urlReturnData?.title}
              </h2>
              <div>
                <table className="detailsTable">
                 <tbody>
                 <tr>
                    <td>Post URL</td>
                    <td>
                      <a href={urlReturnData?.postURL} className="text-blue-600">
                        Click Here
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>Has Audio</td>
                    <td>{urlReturnData?.hasAudio.toString()}</td>
                  </tr>
                  <tr>
                    <td>Video Type</td>
                    <td>{urlReturnData?.isMP4 ? "MP4" : "not know"}</td>
                  </tr>
                 </tbody>
                </table>
              </div>
              <div className="flex space-x-8 items-center pt-6">
                {/* <div className=" flex justify-center items-center">
                  <label className="text-md font-semibold pr-4">Quality</label>
                  <select
                    ref={formateRef}
                    disabled={loading}
                    className="text-sm h-10 bg-[#0070D7] text-white px-2"
                  >
                    {(urlReturnData?.dashContent?.video || []).map(
                      (obj: any) => {
                        return (
                          <option
                            key={obj.format}
                            className=" bg-sky-500"
                            value={JSON.stringify(obj)}
                          >
                            {obj.format}
                          </option>
                        );
                      }
                    )}
                  </select>
                </div> */}
                <div className="text-[14px] py-2 flex justify-center items-center">
                  <button
                    disabled={loading}
                    className="flex justify-center items-center rounded-md w-28 h-10 bg-green-500 text-white"
                    onClick={submitFormateVideo}
                  >
                    <span className="pr-2">{AppIcons("download")}</span>
                    Download
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full">
            <button className="dark:bg-[#222222] bg-[#0070D7] text-center w-full rounded-md mt-10 py-1 text-lg font-bold text-white">
              Download more videos
            </button>
          </div>
        </>
      </Container>
      }
      
    </div>
  );
});

export default Download;
